<template>
	<div id="orthoPlayControlsDiv" class="ortho-controls">
		<!-- <div id="orthoPlayHint">
			<span v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">{{ mode.stageName }}</span>
		</div> -->

		<div id="orthoPlayOriginalDiv" class="orto-no-intraoral toggle-div" v-on:click.stop="showOriginalClick()">
			<input id="orthoPlayOriginalButton" type="checkbox" class="toggle-ortho-play-button" />
			<div id="orthoPlayOriginalLabel" class="toggle-title"
				v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW ORIGINAL</div>
		</div>

		<button id="orthoPlayOriginalColorBtn" v-show="mode.showOriginal" type="button"
			class="orto-no-intraoral original-button" onclick="openColorPicker('original_teeth_color');">
			TEETH COLOR
		</button>

		<div id="orthoPlayShowExtractedDiv" class="toggle-div orto-no-intraoral"
			v-on:click.stop="showExtractedClick($event)">
			<input id="orthoPlayShowExtractedBtn" type="checkbox" class="toggle-ortho-play-button" />
			<div id="orthoPlayShowExtractedLb" class="toggle-title"
				v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW EXTRACTED</div>
		</div>

		<div id="orthoPlayCollisionsDiv" class="toggle-div orto-no-intraoral"
			v-on:click.stop="showCollisionsClick($event)">
			<input id="orthoPlayCollisionsBtn" type="checkbox" class="toggle-ortho-play-button" />
			<div id="orthoPlayCollisionsLb" class="toggle-title"
				v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW COLLISIONS</div>
		</div>

		<div id="orthoPlayAnchorageLossDiv" class="toggle-div orto-no-intraoral"
			v-on:click.stop="showAnchorageLossClick($event)">
			<input id="orthoPlayAnchorageLossBtn" type="checkbox" class="toggle-ortho-play-button" />
			<div id="orthoPlayAnchorageLossLb" class="toggle-title"
				v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW ANCHORAGE LOSS</div>
		</div>
		
	</div>
</template>

<script>
import { OrthoPlanMode, toggleShowOriginal, toggleShowExtracted, toggleShowCollisions, toggleAnchorageLoss, toggleExtract } from "./OrthoPlanMode";

export default {
	name: "OrthoPlayControls",
	props: ["mode", "editContext"],
	components: {},
	methods: {
		showOriginalClick: function () {
			toggleShowOriginal(!OrthoPlanMode.showOriginal, "orthoPlayOriginalDiv");
		},
		showExtractedClick: function () {
			toggleShowExtracted(!OrthoPlanMode.showExtracted, "orthoPlayShowExtractedDiv");
		},
		showCollisionsClick: function () {
			toggleShowCollisions(!OrthoPlanMode.showCollisions, "orthoPlayCollisionsDiv");
		},
		showAnchorageLossClick: function () {
			toggleAnchorageLoss(!OrthoPlanMode.showAnchorageLoss, "orthoPlayAnchorageLossDiv");
		}
	},
	mounted: function () {
		// setTimeout(function () {
		canecode_switch(".toggle-ortho-play-button");
		switchToggle('orthoPlayOriginalDiv', false);
		switchToggle('orthoPlayShowExtractedDiv', true);
		switchToggle('orthoPlayCollisionsDiv', false);
		switchToggle('orthoPlayAnchorageLossDiv', false);
		console.log("OrthoPlayControls mounted", vueApp.hasClosedBones);

		if (!vueApp.hasClosedBones) {
			document.getElementById("orthoPlayAnchorageLossDiv").style.display = "none"
		}

		// }, 999);
	}
};
</script>

<style scoped>
/* @import "opacity.css";
*/
/* .toggle-div {
	top: 50px;
	width: 110px;
} */

.toggle-div {
	position: absolute;
	text-align: center;
	z-index: 9;
	color: #ffffff;
	/*#797979;*/
}

#orthoPlayControlsDiv {
	left: calc(50% - 240px);
	top: 30px;
	width: 440px;
	color: white;
	position: absolute;
}

#orthoPlayHint {
	width: 100px;
	left: calc(50% - 59px);
	text-align: center;
	/* font-weight: bold; */
	/* background-color: transparent; */
}

#orthoPlayOriginalDiv {
	width: 100px;
	left: calc(50% - 280px);
	top: 30px;
}

#orthoPlayOriginalLabel {
	margin-left: -20px;
}

#orthoPlayOriginalColorBtn {
	left: calc(50% - 295px);
}

#orthoPlayShowExtractedDiv {
	width: 120px;
	left: calc(50% - 130px);
	top: 30px;
}

#orthoPlayShowExtractedLb {
	margin-left: -40px;
}

#orthoPlayCollisionsDiv {
	width: 120px;
	left: calc(50% + 20px);
	top: 30px;
}

#orthoPlayCollisionsLb {
	margin-left: -40px;
}

#orthoPlayAnchorageLossDiv {
	width: 120px;
	left: calc(50% + 170px);
	top: 30px;
}

#orthoPlayAnchorageLossLb {
	margin-left: -50px;
}

.toggle-title {
	margin-left: -15px;
}

.original-button {
	position: absolute;
	width: 110px;
	height: 40px;
	border: 0;
	cursor: pointer;
	font-size: 12px;
	background-color: #4687fc;
	z-index: 9;
	top: 110px;
	color: white;
}

#opacityOriginalButton {
	left: calc(50% + 25px);
}
</style>